import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from 'api/client';
import { DocComments } from '../models/response';

export const get = (
    document_id: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<DocComments>> => {
    return client.get<DocComments>(`/document_comments/${document_id}`, customConfig);
};

export const post = (
    document_id: string,
    payload: { text: string },
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> => {
    return client.post<{ msg: string }>(`/document_comments/${document_id}`, payload, customConfig);
};

export const put = (
    document_id: string,
    comment_id: string,
    payload: { text: string },
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> => {
    return client.put<{ msg: string }>(
        `/document_comments/${document_id}/${comment_id}`,
        payload,
        customConfig
    );
};

export const remove = (
    document_id: string,
    comment_id: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> => {
    return client.delete<{ msg: string }>(
        `/document_comments/${document_id}/${comment_id}`,
        customConfig
    );
};
